import {ChangeDetectorRef, Component} from '@angular/core';
import {IHeaderParams} from 'ag-grid-community';
import {IHeaderAngularComp} from 'ag-grid-angular';
import {MatTooltip} from '@angular/material/tooltip';

@Component({
  selector: 'app-day-column-header',
  templateUrl: './day-column-header.component.html',
  styleUrls: ['./day-column-header.component.scss'],
  standalone: true,
  imports: [MatTooltip],
})
export class DayColumnHeaderComponent implements IHeaderAngularComp {
  params: IHeaderParams;
  holiday: string;

  constructor(private cdr: ChangeDetectorRef) {
  }

  agInit(params: any): void {
    this.params = params;
    if (params.column.colDef.apiCol.holiday != undefined) {
      this.holiday = params.column.colDef.apiCol.holiday;
      this.cdr.detectChanges();
    }
  }

  refresh(params: IHeaderParams): boolean {
    this.params = params;
    return false;
  }
}
